export const SET_STATE_ANSWERS = "set_state_answers";
export const SET_ADDITIONAL_ANSWERS = "set_additional_answers";
export const SET_EXTRA_ANSWER = "set_extra_answer";
export const CLEAR_STATE_ANSWERS = "clear_state_answers";